import { Injectable } from '@angular/core';
import {
  ITenantOrganisation,
  IUpdateTenantOrganisationPayload
} from '@pharvio/core/shared';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { TenantOrganisationDataService } from './repositories/tenant-organisation-data.service';

@Injectable()
export class InMemoryTenantOrganisationDataService extends TenantOrganisationDataService {
  private org: ITenantOrganisation = {
    tenantId: 'mock-tenant',
    legalName: null,
    businessType: null,
    businessRegistrationNumber: null,
    taxIdentificationNumber: null,
    incorporationDate: null,
    incorporationCountry: null,
    streetAddress: null,
    city: null,
    stateRegion: null,
    addressCountryCode: null,
    lga: null,
    landmark: null,
    addressDescription: null,
    addressLatitude: null,
    addressLongitude: null,
    phone: null,
    email: null,
    website: null,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  };

  getTenantOrganisation(): Observable<ITenantOrganisation> {
    return of(this.org).pipe(delay(150));
  }

  updateTenantOrganisation(
    payload: IUpdateTenantOrganisationPayload
  ): Observable<ITenantOrganisation> {
    this.org = { ...this.org, ...payload, updatedAt: new Date().toISOString() };
    return of(this.org).pipe(delay(150));
  }
}
